import { Injectable } from '@angular/core';
import { ZOOM_LEVEL } from '@wilson/interfaces';
import { DateTimeFormat } from '@wilson/utils';
import { format } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class DateRangeService {
  private cachedDateRange: { [key: string]: string[] } = {};

  calculateDateRange(zoomLevel: ZOOM_LEVEL, selectedDate: Date): string[] {
    const cacheKey = `${zoomLevel}-${format(
      selectedDate,
      DateTimeFormat.DatabaseDateFormat,
    )}`;

    if (this.cachedDateRange[cacheKey]) {
      return this.cachedDateRange[cacheKey];
    } else {
      const dates: string[] = [];

      const addDateRange = (startDate: Date, endDate: Date) => {
        const current = new Date(startDate);
        while (current <= endDate) {
          dates.push(format(current, DateTimeFormat.DatabaseDateFormat));
          current.setDate(current.getDate() + 1);
        }
      };

      const startDate = new Date(selectedDate);
      const endDate = new Date(selectedDate);

      switch (zoomLevel) {
        case ZOOM_LEVEL.HALF_WEEK:
          endDate.setDate(selectedDate.getDate() + 2);
          addDateRange(startDate, endDate);
          break;

        case ZOOM_LEVEL.DEFAULT:
          endDate.setDate(selectedDate.getDate() + 6);
          addDateRange(startDate, endDate);
          break;

        case ZOOM_LEVEL.HALF_MONTH:
          endDate.setDate(selectedDate.getDate() + 13);
          addDateRange(startDate, endDate);
          break;

        case ZOOM_LEVEL.MONTH:
          endDate.setDate(selectedDate.getDate() + 30);
          addDateRange(startDate, endDate);
          break;

        default:
          break;
      }

      this.cachedDateRange[cacheKey] = dates;
      return dates;
    }
  }
}
